






























import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'CLFooter',
})
export default class CLFooter extends Vue {
  currentYear?: number = 2019;

  created() {
    this.currentYear = (new Date()).getFullYear();
  }
}
